import React, { FC, ReactElement } from "react";
import { useSelector } from "react-redux";
import { List } from "@material-ui/core";

import {
    selectLoadingSearchResult,
    selectSearchedText,
    selectSearchTags,
    selectSearchTweetCount,
    selectSearchUsers
} from "../../../store/ducks/search/selectors";
import Spinner from "../../Spinner/Spinner";
import TextSearchResult from "../TextSearchResult/TextSearchResult";
import UserSearchResult from "../UserSearchResult/UserSearchResult";

interface SearchResultsProps {
  closePopup?: () => void;
  resetText?: () => void;
}

const SearchResults: FC<SearchResultsProps> = ({ closePopup, resetText }): ReactElement => {
    const isLoadingSearchResult = useSelector(selectLoadingSearchResult);
    const searchedText = useSelector(selectSearchedText);
    const tweetCount = useSelector(selectSearchTweetCount);
    const tags = useSelector(selectSearchTags);
    const users = useSelector(selectSearchUsers);

    return (
        <>
            {isLoadingSearchResult ? (
                <Spinner />
            ) : (
                <List>
                    {searchedText && <TextSearchResult text={searchedText} closePopup={closePopup} resetText={resetText} />}
                    {searchedText && tweetCount != 0 && <TextSearchResult text={searchedText} tweetCount={tweetCount} closePopup={closePopup} resetText={resetText} />}
                    {tags?.map((tag, index) => <TextSearchResult key={index} text={tag} closePopup={closePopup} resetText={resetText} />)}
                    {users?.map((user) => <UserSearchResult key={user.id} user={user} closePopup={closePopup} resetText={resetText}/>)}
                </List>
            )}
        </>
    );
};

export default SearchResults;
